import React, { ChangeEvent, KeyboardEvent, useState, useEffect } from 'react'
import { http } from './../../Service/http'
import { report } from './../../store/report'
import Input from './../../Components/Select/Input'
import { BsSearch } from 'react-icons/bs'
import { direction } from '../../store/direction'
import { useTranslation } from 'react-i18next'

function ApplicaionsDone() {
	const [searchText, setText] = useState<string>('')
	const { t } = useTranslation()

	const getStudentsByName = async () => {
		const res = await http.post('/report/reportApplicationDone', {
			s_fio_document: searchText,
			status: true
		})
		report.newReport(res.data.reportApplicationDone)
	}

	useEffect(() => {
		if (direction.leftOrRight == 'right') {
			getStudentsByName()
		}
	}, [direction.leftOrRight])

	return (
		<div style={{ margin: '0 auto', width: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
			<Input
				style={{ width: '80%', zIndex: '1' }}
				placeholder={t('st:placeHolder.byFio')}
				value={searchText}
				oninput={setText}
				keyDown={(e: KeyboardEvent<HTMLInputElement>) => {
					if (e.key == 'Enter') {
						getStudentsByName()
					}
				}}
			/>
			<BsSearch className='search_icon' onClick={getStudentsByName} />
		</div>
	)
}

export default ApplicaionsDone
